import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  tabPanel: {
    padding: 0,
    background: 'transparent',
    minHeight: 0,
    borderRadius: 0,
    boxShadow: 'none',
    width: '100%'
  }
}));

/**
 * CustomTabPanel - A reusable tab panel component
 * @param {Object} props - Component props
 * @returns {React.Component} - A tab panel component
 */
function CustomTabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{ width: '100%' }}
      hidden={value !== index}
      id={`syllabus-tabpanel-${index}`}
      aria-labelledby={`syllabus-tab-${index}`}
      className={classes.tabPanel}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

/**
 * Helper function for tab accessibility props
 * @param {number} index - The tab index
 * @returns {Object} - Accessibility props
 */
export function a11yProps(index) {
  return {
    id: `syllabus-tab-${index}`,
    'aria-controls': `syllabus-tabpanel-${index}`
  };
}

export default CustomTabPanel;
